import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    modules:{

    },
    state: {
        isMobile: null,
        showMobileMenu: false,
        url:'',
        isIE:false,
        is4k:false,
        isSafari:false,
        supportsWebp:false,

        showIOS: null,
        showAndroid: null,
    },

    mutations: {

        storeIsMobile (state, value) {
            //console.log('ready 2',value)
            state.isMobile = value;
        },

        storeShowMobileMenu (state, value) {
            state.showMobileMenu = value && state.isMobile;
        },

        storeUrl (state, value) {
            state.url = value;
        },

        storeIsIE(state,value){
            state.isIE = value;
        },

        storeIs4k(state,value){
            state.is4k = value;
        },

        storeIsSafari(state,value){
            state.isSafari = value;
        },
        supportsWebp(state,value){
            state.supportsWebp = value;
        },

        storeShowIos (state, value) {
          state.showIOS = value;
        },

        storeShowAndroid (state, value) {
          state.showAndroid = value;
        },


    },

    getters:{
        ageGateCheck: (state) => (id) => {

            let ageCheck = checkAge();



           // console.log('ageCheck',ageCheck);
            return ageCheck;
        },
    },

    actions:{

    }
});
